import Cookies from 'js-cookie'
import AgentService from '../../api/agent.service'

// export const namespaced = true 

const state = {
     // set token null if user is not logged in
    stepCount: parseInt(Cookies.get('stepCount'))  || 0,
    businessInfo: Cookies.getJSON('businessInfo'),
    companyInfo: Cookies.getJSON('companyInfo'),
	storeInfo: Cookies.getJSON('storeInfo'),
	showProgressBar: Cookies.get('showProgressBar') || false,
	progressBarPercentage: Cookies.get('progressBarPercentage') || 0,
	accountName: Cookies.get('accountInfo'),

}

const getters = {
     // return boolen if token is exist or not
    getStepCount: (state) => {
        // console.log("authToken typeof | ", typeof(state.authToken))
        return state.stepCount
    },
    getBusinessInfo:(state) =>{
        return state.businessInfo
    },
    getCompanyInfo:(state) =>{
        return state.companyInfo
    },
    getStoreInfo:(state) =>{
        return state.storeInfo
	},
	getShowProgressBar:(state) =>{
		return state.showProgressBar
	},
	getProgressBarPercentage: (state) =>{
		return parseInt(state.progressBarPercentage) 
	},
	getAccountName: (state) =>{
		return state.accountName 
	},

	
}

const actions = {
    setStepCount({ commit }, current) {
        commit('setStepCurrentCount', current);
        Cookies.set('stepCount', current, { expires: 1/48 });// Expires 30mins
    },
	removeCount({ commit }) {
        commit('setStepCurrentCount', 0);
        Cookies.set('stepCount', 0, { expires: 1/48 });// Expires 30mins
    },
    setBusinessInfo({ commit }, data) {
        commit('updateBusinessInfo', data);
        Cookies.set('businessInfo', data, { expires: 1/48 });// Expires 30mins
    },
    setCompanyInfo({ commit }, data) {
        commit('updateCompanyInfo', data);
        Cookies.set('companyInfo', data, { expires: 1/48 });// Expires 30mins
    },
    setStoreInfo({ commit }, data) {
		commit('updateStoreInfo', data);
		Cookies.set('storeInfo', data, { expires: 1/48 });// Expires 30mins
	},

	setAccountName({ commit }, data) {
		commit('setAccountName', data);
		Cookies.set('accountName', data, { expires: 1/48 }); // Expires 30mins
	},

	setProgressBar({ commit }, data){
		commit('updateProgressBar', data);
		Cookies.set('showProgressBar', data, { expires: 1/48 }); // Expires 30mins
	},
	setPercentageBar({ commit }, data){
		commit('updateProgressBarPercentage', data);
		Cookies.set('progressBarPercentage', data, { expires: 1/48 }); // Expires 30mins
	},
	getRetailCenterDetails({ rootState,dispatch }){
		const { authToken } =  rootState.auth;
		const { agentProfile } =  rootState.agentProfile;
		let retailCenterId = agentProfile.retailCentreId
		return AgentService.getRetailCenterDetailsAsync(authToken, retailCenterId).then(
				response => {
					// console.log("Response  | ", response)
					// setBusinessDetails(response)
					dispatch('setBusinessDetails',response )
					dispatch('setCompanyDetails',response )
					dispatch('setStoreDetails',response )
					return Promise.resolve(response);
				},
				error => {
					console.log("Error | ", error)
					return Promise.reject(error);
				}
		);
	},

	addBusinessInfo({ rootState }, request_data){
		
        const { authToken } =  rootState.auth;
		const { agentProfile } =  rootState.agentProfile;
		
        return AgentService.addBusinessInfoAsync(authToken ,agentProfile.clientId, request_data).then(
            response => {
              return Promise.resolve(response);
            },
            error => {
              return Promise.reject(error);
            }
        );
	},
	
	addCompanyInfo({ rootState }, request_data){
		
        const { authToken } =  rootState.auth;
        const { agentProfile } =  rootState.agentProfile;
        return AgentService.addCompanyInfoAsync(authToken ,agentProfile.clientId, request_data).then(
            response => {
              return Promise.resolve(response);
            },
            error => {
              return Promise.reject(error);
            }
        );
	},
	
	onboardingBusinesCompany({ dispatch },request_data){
		
		let businessInfo = dispatch('addBusinessInfo', request_data.businessInfo);
		let companyInfo = dispatch('addCompanyInfo',request_data.companyInfo);
  
		return Promise.all([businessInfo,companyInfo])
		.then((response) => {
			return Promise.resolve(response);
		},
		error => {
			console.log("Error | ", error)
			return Promise.reject(error);
		}
		);
	},

	setCompanyDetails({ dispatch }, data){

		let result = data.data;
		let companyInfoform = {};

		companyInfoform.companyName = result.name,
		companyInfoform.regionId = result.regionId,
		companyInfoform.districtId = result.districtId,
		companyInfoform.communityId = result.communityId,
		companyInfoform.isBusinessRegistered = result.registrarGeneralYear !== '' && result.registrationNumber !== '' ? 'true' : 'false',
		companyInfoform.yearOfRegistration = result.registrarGeneralYear,
		companyInfoform.businessRegNumber = result.registrationNumber,
		companyInfoform.vetCouncil = result.registeredVeterinaryYear !== '' && result.registrationStatus !== '' ? 'true' : 'false',
		companyInfoform.vetCouncilYearOfReg = result.registeredVeterinaryYear,
		companyInfoform.vetCouncilRegState = result.registrationStatus,
		companyInfoform.communityId = result.communityId,
		companyInfoform.tin = result.tin
		companyInfoform.numberOfStaffs = result.numberOfStaff

		// console.log('companyInfoform in setttings | ', companyInfoform)
		dispatch('setCompanyInfo', companyInfoform)

	},

	setStoreDetails({ dispatch }, data ){
		let storeInfoform = {}
		let result = data.data;
		// console.log('result in setttings | ', result)

		storeInfoform.storeType = result.storeType.toString(),
		storeInfoform.region = result.region,
		storeInfoform.district = result.district,
		storeInfoform.storageSize = result.storageSize,
		storeInfoform.hasRefrigerator = result.hasRefrigerator.toString(),
		storeInfoform.hasBackupEnergy = result.hasBackupEnergy.toString(),
		storeInfoform.lockableStorage = result.lockableStorage.toString(),
		storeInfoform.energySources = result.energySources,
		storeInfoform.backupEnergySources = result.backupEnergySources

		// console.log('storeInfoform in onboarding | ', storeInfoform)
		dispatch('setStoreInfo', storeInfoform)

	},
	setBusinessDetails({ dispatch }, data){
		// console.log('data | ', data)
		let result = data.data;
		let businessInfoform = {};

		businessInfoform.ownerName = result.ownerName,
		businessInfoform.age = result.age,
		businessInfoform.gender = result.gender,
		businessInfoform.ownerMobile =  result.ownerMobile,
		businessInfoform.educationLevel = result.educationLevel.toString(),
		businessInfoform.fieldOfTraining = result.fieldOfTraining,
		businessInfoform.numberOfStores =  result.numberOfStores,
		businessInfoform.yearsInBusiness = result.yearsInBusiness

		// console.log('businessInfoform in onboarding | ', businessInfoform)

		// this.setBusinessInfo(businessInfoform)
		dispatch('setBusinessInfo', businessInfoform)
	},
}

 const mutations = {
    setStepCurrentCount: (state, stepCount) => {
        state.stepCount = stepCount;
    },
    updateBusinessInfo: (state, data) => {
        state.businessInfo = data;
    },
    updateCompanyInfo: (state, data) => {
        state.companyInfo = data;
    },
    updateStoreInfo: (state, data) => {
        state.storeInfo = data;
	},
	updateProgressBar: (state, data) => {
        state.showProgressBar = data;
	},
	updateProgressBarPercentage: (state, data) => {
        state.progressBarPercentage = data;
	},
	setAccountName: (state, data) => {
        state.accountName = data;
	}
 }

 export default{
	// namespaced,
    state,
    getters,
    actions,
    mutations
}